import { combineReducers } from "redux";

import LayoutReducer, {State as LayoutState} from "./layoutReducer";
import CompanyReducer, {State as CompanyState} from "./companies.reducer"
import companyValidationReducer, {State as CompanyValidationState} from "./companyValidations.reducer"
import TeamReducer, {State as TeamState} from "./teams.reducer"
import UserReducer, {State as UserState} from "./users.reducer"
import AuthReducer, { State as AuthState } from "./auth.reducer"
import RoleReducer, {State as RoleState} from "./roles.reducer"
import AdminUserReducer, {State as AdminUserState} from "./adminUsers.reducer"
import ValidationsReducer, {State as ValidationsState} from "./validations.reducer"
import DashboardReducer, {State as DashboardState} from "./dashboard.reducer"
import APIUserReducer, {State as APIUserState} from './apiUsers.reducer'
import AnnouncementsReducer from './announcements.reducer'
import LiveUpdateValidationsReducer, {State as LiveUpdateValidationsState} from './liveUpdateValidations.reducer'

export interface RootState {  	
	layout: LayoutState;
	company: CompanyState;
	team: TeamState;
  user: UserState;
  auth: AuthState;
  role: RoleState;
  adminUser: AdminUserState;
  validations:ValidationsState;
  dashboard: DashboardState,
  apiUsers: APIUserState,
  companyValidation:CompanyValidationState,
  announcements: any,
  liveUpdateValidations: LiveUpdateValidationsState
  }

const reducers = combineReducers<RootState>({
	layout: LayoutReducer,	
	company: CompanyReducer,
	team: TeamReducer,
  user: UserReducer,
  role: RoleReducer,
  auth: AuthReducer,
  adminUser: AdminUserReducer,
  validations:ValidationsReducer,
  dashboard: DashboardReducer,
  apiUsers:  APIUserReducer,
  companyValidation: companyValidationReducer,
  announcements: AnnouncementsReducer,
  liveUpdateValidations: LiveUpdateValidationsReducer
});

export default reducers;